import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaClipboard } from "react-icons/fa"; // Import the clipboard icon from react-icons
import { MdContentCopy } from "react-icons/md";

import teacher_placeholder from "../../../assets/teacher_placeholder.svg";
import { useSnack } from "../../../hooks/useSnack";
import Button from "../../Button";
import Modal from "../../Modal";

const SuccessResetPasswordModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState("");
  const [tooltipText, setTooltipText] = useState("copy"); // State for tooltip text
  const { showSnack } = useSnack();

  useImperativeHandle(ref, () => ({
    openModal(data) {
      setData(data);
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const copyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    setTooltipText("copied"); // Change tooltip text to "Copied"
    setTimeout(() => setTooltipText("copy"), 2000); // Reset back to "Copy" after 2 seconds
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      header={<p className="text-green-600">{t("password_reset_successfully")}</p>}
    >
      {/* Modal Body Content */}
      <div className="flex flex-col items-center gap-6">
        <div className="flex w-64 flex-col items-center justify-center gap-2 rounded-xl bg-blue-200 p-3 py-5 dark:bg-dark-background">
          <img
            className="border-24 h-36 w-36 rounded-full border object-cover dark:border-[#FAFBFC0D]"
            src={data?.teacher?.image || teacher_placeholder}
            alt="icon"
          />
          <p className="text-center text-sm dark:text-gray-100">{data?.teacher?.name}</p>
        </div>
        <div className="text-center">
          <div className="mt-2 flex items-center justify-center rounded-lg bg-gray-50 p-2 text-sm text-gray-700 shadow-sm dark:bg-dark-background dark:text-dark-mutedText dark:text-mutedText">
            <p>{data?.password}</p>
            <Button
              tooltip={t(tooltipText)} // Display the dynamic tooltip text
              color="white"
              variant="text"
              icon={<MdContentCopy size={20} />}
              onClick={() => copyToClipboard(data?.password || "")}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
});

export default SuccessResetPasswordModal;
